module.exports = __webpack_public_path__ + "img/calendar-banner-mob.aa960c68.gif";